import React from "react";
import moment from "moment";
import {
  Button,
  ButtonToolbar,
  Input,
  Table,
  Pagination,
  Dropdown,
  IconButton,
  Popover,
  Whisper,
} from "rsuite";
import { FiMenu } from "react-icons/fi";
import { purchaseOrderModel } from "../../formsValidation";
import { useEffect, createContext } from "react";
import { frontDB } from "../../frontDB";
import {
  ActionsIcon,
  Status,
} from "../Settings/Components/Locations/Locations";
import InvoiceIconFile from "../../Components/Icons/invoice.png";
import DryDockIconFile from "../../Components/Icons/drydock.png";
import { default as PurchaseOrdersHeader } from "./Components/PurchaseOrdersHeader/PurchaseOrdersHeader";
import styles from "./PurchaseOrders.module.css";
import { usePurchaseOrders } from "./usePurchaseOrders";
import { usePurchaseOrdersHeader } from "./Components/PurchaseOrdersHeader/usePurchaseOrdersHeader";
import {
  country_list,
  priorities,
  departments,
  requisition_types,
} from "../Settings/Data/lists";
import PageContainer from "../../Components/PageContainer/PageContainer";
import SearchComponent2 from "../../Components/SearchComponent2/SearchComponent2";
import ManufacturerSearch from "./Components/ManufacturerSearch/ManufacturerSearch";
import ItemsBlock from "./Components/ItemsBlock/ItemsBlock";
import PriceComparisonBlock from "./Components/PriceComparisonBlock/PriceComparisonBlock";
import AttachedInvoicesBlock from "./Components/AttachedInvoicesBlock/AttachedInvoicesBlock";
import OrderAmountBlock from "./Components/OrderAmountBlock/OrderAmountBlock";
import ActionLogs from "./Components/ActionLogs/ActionLogs";
import {
  StatusWithTooltip,
  capitalizeFirstLetter,
  getAccessLevel,
  getInputsStatus,
  isItemReadonly,
  isItemsReadonly,
  isLocationBlockAvaliable,
  isMessageBlockAvaliable,
  isReceivedInputAvaliable,
  isVendorsBlockAvaliable,
  isAttachedInvoicesBlockAvaliable,
  isOrderAmountBlockAvaliable,
} from "../../helperFunctions";
import MessageBlock from "./Components/MessageBlock/MessageBlock";
import VendorsBlock from "./Components/VendorsBlock/VendorsBlock";
import LocationBlock from "./Components/LocationBlock/LocationBlock";
import MainForm from "./Components/MainForm/MainForm";
import ArowBackIcon from "@rsuite/icons/ArowBack";
import ConfirmationModal from "../../Components/ConfirmationModal/ConfirmationModal";
import { useConfirmationModal } from "../../Components/ConfirmationModal/useConfirmationModal";
import DocumentTitle from "../../Components/DocumentTitle";
const { Column, HeaderCell, Cell } = Table;

export const PurchaseOrderContext = createContext();

function PurchaseOrders() {
  DocumentTitle("RitePMS Office - Requisitions lists");
  let { accounts, locations, location } = frontDB();

  let {
    requisitionTypeHandler,
    deletePurchaseOrder,
    tableLoading,
    locationHandler,
    accountHandler,
    priorityHandler,
    purchaseOrders,
    setActivePage,
    activePage,
    itemsPerPage,
    purchaseOrdersArrayLength,
    departmentHandler,
    section,
    formHandler,
    form,
    dateHandler,
    formMode,
    showEditPurchaseOrder,
    getPurchaseOrders,
    createPurchaseOrder,
    updatePurchaseOrder,
    cancel,
    componentHandler,
    onManufactureChange,
    onManufactureCreate,
    onManufacturerChangeName,
    itemsHandler,
    approveByCrewChief,
    message,
    messageHandler,
    notApproveByOffice,
    approveByOffice,
    rejectByOffice,
    submitReceived,
    invoiceReceive,
    archivePO,
    cancelOrder,
    setPOStatus,
    certExpDateHandler,
    bestETAHandler,
    dryDockHandler,
    countFormChanges,
    resetFormChanges,
    sortColumn,
    handleSort,
    orderAmountHandler,
    orderAmountCurrencyHandler,
  } = usePurchaseOrders();

  const accessLevel = getAccessLevel();

  const { showConfirmationModal } = useConfirmationModal();

  useEffect(() => {
    getPurchaseOrders();
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        ConfirmationModalNew(
          cancel,
          countFormChanges,
          showConfirmationModal,
          resetFormChanges,
        );
      }
    };
    window.addEventListener("keydown", handleEsc);
  }, [activePage]);

  const ActionsCell = ({ rowData, dataKey, ...props }) => {
    return (
      <Cell {...props}>
        <div
          className={styles.actions_cell_container}
          style={{ display: "flex", alignItems: "center", gap: "4px" }}
        >
          {rowData.status !== "deleted" && (
            <div style={{ width: 25, height: 20, marginLeft: "1px" }}>
              <ActionsIcon
                type="edit"
                onEdit={() => {
                  showEditPurchaseOrder(rowData[dataKey]);
                }}
              />
            </div>
          )}
          {rowData.invoiceReceivedDate !== undefined && (
            <div style={{ width: 25, height: 20, marginLeft: "1px" }}>
              <InvoiceReceivedIcon
                invoiceReceivedDate={rowData.invoiceReceivedDate}
              />
            </div>
          )}

          <div
            style={{
              width: 20,
              height: 20,
              marginBottom: 3,
              marginLeft: "-4px",
            }}
          >
            <Whisper
              delay={300}
              placement="bottomStart"
              controlId="control-dry-dock"
              trigger="hover"
              speaker={<Popover>Dry Dock Purchase Order</Popover>}
            >
              <img
                style={{
                  width: 25,
                  backgroundColor: "transparent",
                  overflow: "visible",
                  display: rowData?.dryDock ? "inline" : "none",
                }}
                src={DryDockIconFile}
                alt="Dry Dock"
              />
            </Whisper>
          </div>
        </div>
      </Cell>
    );
  };

  let StatusCell = ({ rowData, dataKey, ...props }) => {
    return (
      <Cell {...props}>
        <StatusWithTooltip status={rowData[dataKey]} />
      </Cell>
    );
  };

  let TypeCell = ({ rowData, dataKey, ...props }) => {
    let type = rowData[dataKey];
    if (!type) type = "";
    if (type == "Stores") type = "ST";
    if (type == "Spares") type = "SP";
    if (type == "Service") type = "SE";

    return (
      <Cell {...props}>
        <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
          {type}
        </div>
      </Cell>
    );
  };

  let allPurchaseOrdersSection = () => {
    return (
      <>
        <PurchaseOrdersHeader />
        <div className={styles.table_container}>
          <div className={styles.table_scroll}>
            <Table
              className={styles.purchase_orders_table}
              sortColumn={sortColumn}
              onSortColumn={handleSort}
              height={500}
              data={purchaseOrders}
              loading={tableLoading}
              onRowClick={(rowData) => {
                showEditPurchaseOrder(rowData["_id"]);
              }}
            >
              <Column sortable minWidth={130} flexGrow={13} resizable>
                <HeaderCell>#</HeaderCell>
                <Cell dataKey="requisitionNumber" />
              </Column>

              <Column sortable minWidth={305} flexGrow={30} resizable>
                <HeaderCell>Requisition title</HeaderCell>
                <Cell dataKey="title" />
              </Column>

              <Column sortable minWidth={40} flexGrow={4} resizable>
                <HeaderCell>Type</HeaderCell>
                <TypeCell dataKey="type" />
              </Column>

              <Column minWidth={135} flexGrow={13} resizable>
                <HeaderCell>Vessel</HeaderCell>
                <Cell dataKey="locationName" />
              </Column>

              <Column sortable minWidth={120} flexGrow={12} resizable>
                <HeaderCell>Created</HeaderCell>
                <Cell dataKey="issued" />
              </Column>

              <Column minWidth={120} flexGrow={12} resizable>
                <HeaderCell>Ordered</HeaderCell>
                <Cell dataKey="ordered" />
              </Column>

              <Column minWidth={90} flexGrow={9} resizable>
                <HeaderCell>Vendor</HeaderCell>
                <Cell dataKey="vendorName" />
              </Column>

              <Column sortable minWidth={90} flexGrow={9} resizable>
                <HeaderCell>Transit</HeaderCell>
                <Cell dataKey="itemsLocation" />
              </Column>

              <Column minWidth={145} flexGrow={14} resizable>
                <HeaderCell>Status</HeaderCell>
                <StatusCell dataKey="status" />
              </Column>

              <Column minWidth={70} flexGrow={7}>
                <HeaderCell>Action</HeaderCell>
                <ActionsCell dataKey="_id" />
              </Column>
            </Table>
          </div>

          <div className={styles.pagination_container}>
            <Pagination
              prev
              next
              first
              last
              ellipsis
              size="xs"
              layout={["total", "-", "pager"]}
              total={purchaseOrdersArrayLength}
              maxButtons={10}
              limit={itemsPerPage}
              activePage={activePage}
              onChangePage={setActivePage}
            />
          </div>
        </div>
      </>
    );
  };

  let accountNumberOptions = accounts.map((item) => ({
    category: item.category,
    label: `${item.number} ${item.description}`,
    value: item._id,
  }));

  let locationOptions = [
    ...locations.map((item) => ({ label: item?.name, value: item?._id })),
  ];

  let departmentOptions = [
    ...departments.map((item) => ({ label: item, value: item })),
  ];

  let priorityOptions = [
    ...priorities.map((item) => ({ label: item, value: item })),
  ];

  let requisitionTypeOptions = [
    ...requisition_types.map((item) => ({ label: item, value: item })),
  ];

  if (form.status == "approved by crew chief") form.status = "approved by crew";

  const showReceivedItems = isReceivedInputAvaliable(accessLevel, form.status);
  const inputsStatus = getInputsStatus(form.status, accessLevel);
  const itemsReadonly = isItemsReadonly(accessLevel, form.status);
  const itemReadonly = false; //isItemReadonly(accessLevel, form.status);
  const showMessageBlock = isMessageBlockAvaliable(accessLevel, form.status);
  const showVendorsBlock = isVendorsBlockAvaliable(
    accessLevel,
    form.status,
    form?.vendors,
  );
  const showLocationBlock = isLocationBlockAvaliable(accessLevel, form.status);
  const showAttachedInvoicesBlock = isAttachedInvoicesBlockAvaliable(
    accessLevel,
    form.status,
  );
  const showOrderAmountBlock = isOrderAmountBlockAvaliable(
    accessLevel,
    form.status,
  );
  const showOtherActions = () => {
    if (accessLevel >= 3) return true;
    else return false;
  };

  let form_section = (
    <>
      <div className={styles.purchaseOrders_header}>
        <div className={styles.purchaseOrders_header_title}>
          <div
            className={styles.arrow_back_btn}
            onClick={() => {
              ConfirmationModalNew(
                cancel,
                countFormChanges,
                showConfirmationModal,
                resetFormChanges,
              );
            }}
          >
            <ArowBackIcon className={styles.arrow_back} />
          </div>
          {formMode == "create" ? (
            "Add Requisition list "
          ) : (
            <>
              {" "}
              Edit Requisition list | {form.requisitionNumber}{" "}
              {
                <>
                  <span>
                    <StatusWithTooltip status={form.status} />
                  </span>
                  <span style={{ width: 40 }}>
                    {InvoiceReceivedIcon(form?.invoiceReceivedDate)}
                  </span>
                  {form?.receivedDate && (
                    <span
                      style={{
                        fontSize: 14,
                        fontWeight: 400,
                        paddingTop: 1,
                        marginRight: 8,
                      }}
                    >
                      Delivered:{" "}
                      {moment(form.receivedDate).format("DD/MM/YYYY")}
                    </span>
                  )}
                  {}
                  {showOtherActions() && (
                    <OtherActions
                      orderStatus={form.status}
                      notApproveByOffice={notApproveByOffice}
                      cancelOrder={() => {
                        showConfirmationModal("cancel", cancelOrder);
                      }}
                      setPOStatus={setPOStatus}
                      archivePO={archivePO}
                      showConfirmationModal={showConfirmationModal}
                    />
                  )}
                </>
              }
            </>
          )}
        </div>
      </div>

      <div className={styles.form_container}>
        <MainForm
          inputsStatus={inputsStatus}
          purchaseOrderModel={purchaseOrderModel}
          formHandler={formHandler}
          form={form}
          locationHandler={locationHandler}
          locationOptions={locationOptions}
          departmentHandler={departmentHandler}
          departmentOptions={departmentOptions}
          requisitionTypeHandler={requisitionTypeHandler}
          requisitionTypeOptions={requisitionTypeOptions}
          accountHandler={accountHandler}
          accountNumberOptions={accountNumberOptions}
          priorityHandler={priorityHandler}
          priorityOptions={priorityOptions}
          onManufacturerChangeName={onManufacturerChangeName}
          onManufactureCreate={onManufactureCreate}
          componentHandler={componentHandler}
          dateHandler={dateHandler}
          certExpDateHandler={certExpDateHandler}
          bestETAHandler={bestETAHandler}
          dryDockHandler={dryDockHandler}
        />

        <PurchaseOrderContext.Provider value={form}>
          <ItemsBlock
            readonly={itemsReadonly}
            onChange={itemsHandler}
            showReceived={showReceivedItems}
            itemReadonly={itemReadonly}
          />
        </PurchaseOrderContext.Provider>

        {showVendorsBlock && (
          <VendorsBlock
            purchaseOrderId={form?._id}
            vendors={form?.vendors}
            countFormChanges={countFormChanges}
          />
        )}

        {showVendorsBlock && (
          <PriceComparisonBlock
            items={form?.items}
            vendors={form?.vendors}
            itemVendorPrices={form?.itemVendorPrices || {}}
            poStatus={form?.status}
          />
        )}

        {/* <OrderAmountBlock
          showOrderAmountBlock={(form?.vendors || []).some(
            (v) => v?.status === "approved" || v?.status === "po placed"
          )}
          form={form}
          orderAmountHandler={orderAmountHandler}
          orderAmountCurrencyHandler={orderAmountCurrencyHandler}
        /> */}

        {showLocationBlock && (
          <LocationBlock
            purchaseOrderId={form?._id}
            itemsLocation={form?.itemsLocation}
          />
        )}

        {showAttachedInvoicesBlock && (
          <AttachedInvoicesBlock locationId={form?.locationId} />
        )}

        {showMessageBlock && (
          <MessageBlock message={message} onChange={messageHandler} />
        )}

        <ButtonToolbar style={{ marginTop: "20px" }}>
          <FormButtons
            dryDock={form?.dryDock || false}
            orderStatus={form.status}
            formMode={formMode}
            createPurchaseOrder={createPurchaseOrder}
            updatePurchaseOrder={updatePurchaseOrder}
            cancel={() => {
              ConfirmationModalNew(
                cancel,
                countFormChanges,
                showConfirmationModal,
                resetFormChanges,
              );
            }}
            approveByCrewChief={approveByCrewChief}
            notApproveByOffice={notApproveByOffice}
            approveByOffice={approveByOffice}
            rejectByOffice={() => {
              showConfirmationModal("reject", rejectByOffice);
            }}
            submitReceived={submitReceived}
            invoiceReceived={invoiceReceive}
          />
        </ButtonToolbar>
        {form?.actions?.length && <ActionLogs actions={form.actions} />}
      </div>
    </>
  );

  //!Render

  return (
    <>
      <PageContainer>
        {section == "all purchaseOrders" && allPurchaseOrdersSection()}
        {section == "form" && form_section}
      </PageContainer>

      <ConfirmationModal />
    </>
  );
}

export default PurchaseOrders;

const Textarea = React.forwardRef((props, ref) => (
  <Input {...props} as="textarea" ref={ref} />
));

const OtherActions = ({
  orderStatus,
  notApproveByOffice,
  cancelOrder,
  setPOStatus,
  archivePO,
  showConfirmationModal,
}) => {
  const accessLevel = getAccessLevel();
  if (accessLevel < 3) return <></>;
  return (
    <>
      <div
        style={{
          width: "50px",
          display: "flex",
          justifyContent: "flex-start",
        }}
      >
        <Dropdown
          placement="bottomStart"
          renderToggle={(props, ref) => (
            <IconButton
              {...props}
              ref={ref}
              icon={<FiMenu style={{ height: 20, width: 20 }} />}
              appearance="subtle"
              style={{
                width: "auto",
                height: 37,
                marginLeft: 0,
                display: "flex",
                alignItems: "center",
                padding: "0 12px",
              }}
            ></IconButton>
          )}
        >
          {["vendor approved"].includes(orderStatus) && (
            <>
              <Dropdown.Item
                onClick={() => {
                  showConfirmationModal("confirmStatusChange", () =>
                    setPOStatus("items in transit"),
                  );
                }}
              >
                <div style={{ marginLeft: 10, width: 260 }}>
                  Set status to 'items in transit'
                </div>
              </Dropdown.Item>
            </>
          )}

          {["items in transit"].includes(orderStatus) && (
            <>
              <Dropdown.Item
                onClick={() => {
                  showConfirmationModal("confirmStatusChange", () =>
                    setPOStatus("inquired"),
                  );
                }}
              >
                <div style={{ marginLeft: 10, width: 260 }}>
                  Set status to 'Inquired'
                </div>
              </Dropdown.Item>
            </>
          )}

          {["invoice received"].includes(orderStatus) && (
            <>
              <Dropdown.Item
                onClick={() => {
                  showConfirmationModal("confirmStatusChange", () =>
                    archivePO(),
                  );
                }}
              >
                <div style={{ marginLeft: 10, width: 260 }}>
                  Set status to 'Archived'
                </div>
              </Dropdown.Item>
            </>
          )}
          {[
            "approved by crew",
            "approved by crew chief",
            "approved by office",
            "not approved by office",
            "inquired",
            "vendor approved",
            "po placed",
          ].includes(orderStatus) && (
            <Dropdown.Item onClick={cancelOrder}>
              <div style={{ marginLeft: 10, width: 260 }}>
                Cancel requisition list
              </div>
            </Dropdown.Item>
          )}

          {![
            "not approved by office",
            "archived",
            "deleted",
            "canceled",
          ].includes(orderStatus) && (
            <Dropdown.Item
              onClick={() => {
                showConfirmationModal("notApproveByOffice", notApproveByOffice);
              }}
            >
              <div style={{ marginLeft: 10, width: 260 }}>
                Set status to 'Not approved by office'
              </div>
            </Dropdown.Item>
          )}
        </Dropdown>
      </div>
    </>
  );
};

const ConfirmationModalNew = (
  onClose,
  countFormChanges,
  showConfirmationModal,
  resetFormChanges,
) => {
  if (countFormChanges > 2) {
    showConfirmationModal("cancelexit", onClose);
  } else {
    resetFormChanges();
    onClose();
  }
};

const FormButtons = ({
  dryDock,
  orderStatus,
  formMode,
  createPurchaseOrder,
  updatePurchaseOrder,
  cancel,
  approveByCrewChief,
  approveByOffice,
  notApproveByOffice,
  rejectByOffice,
  submitReceived,
  invoiceReceived,
}) => {
  const accessLevel = getAccessLevel();

  const createAndUpdateButton = (
    <Button
      onClick={formMode == "create" ? createPurchaseOrder : updatePurchaseOrder}
      appearance="primary"
      style={{ width: "200px" }}
    >
      Save
    </Button>
  );

  const approveByCrewChiefButton = (
    <Button
      onClick={approveByCrewChief}
      appearance="primary"
      color="green"
      style={{ width: "200px" }}
    >
      Approve
    </Button>
  );

  const closeButton = (
    <Button onClick={cancel} appearance="default" style={{ width: "200px" }}>
      Close
    </Button>
  );

  const approveByOfficeButton = (
    <>
      <Button
        onClick={approveByOffice}
        appearance="primary"
        color="green"
        style={{ width: "200px" }}
      >
        Approve
      </Button>
    </>
  );

  const notApproveByOfficeButton = (
    <>
      <Button
        onClick={notApproveByOffice}
        appearance="primary"
        color="violet"
        style={{ width: "200px" }}
      >
        Not approve
      </Button>
    </>
  );

  const rejectByOfficeButton = (
    <>
      <Button
        onClick={rejectByOffice}
        appearance="primary"
        color="red"
        style={{ width: "200px" }}
      >
        Reject
      </Button>
    </>
  );

  const submitReceivedButton = (
    <>
      <Button
        onClick={submitReceived}
        appearance="primary"
        color="violet"
        style={{ width: "200px" }}
      >
        Submit received
      </Button>
    </>
  );

  const invoiceReceivedButton = (
    <>
      <Button
        onClick={invoiceReceived}
        appearance="primary"
        color="green"
        style={{ width: "200px" }}
      >
        Set Invoice received
      </Button>
    </>
  );

  if (accessLevel == 1) {
    if (orderStatus == "draft")
      return (
        <>
          {" "}
          {createAndUpdateButton} {closeButton}{" "}
        </>
      );
    if (orderStatus == "not approved by office")
      return (
        <>
          {" "}
          {createAndUpdateButton} {closeButton}{" "}
        </>
      );
    return <> {closeButton}</>;
  }

  if (accessLevel == 2) {
    if (orderStatus == "draft")
      return (
        <>
          {createAndUpdateButton} {approveByCrewChiefButton} {closeButton}{" "}
        </>
      );
    if (orderStatus == "not approved by office")
      return (
        <>
          {" "}
          {createAndUpdateButton} {approveByCrewChiefButton} {closeButton}{" "}
        </>
      );
    if (orderStatus == "delivered")
      return (
        <>
          {" "}
          {submitReceivedButton} {closeButton}{" "}
        </>
      );
    return <> {closeButton}</>;
  }

  if (accessLevel >= 3) {
    if (orderStatus == "draft" && !dryDock)
      return (
        <>
          {createAndUpdateButton} {approveByCrewChiefButton} {closeButton}{" "}
        </>
      );

    if (orderStatus == "draft" && dryDock)
      return (
        <>
          {createAndUpdateButton} {approveByOfficeButton}
          {closeButton}
          {<div style={{ width: "200px", height: "80px" }}></div>}
        </>
      );
    if (
      orderStatus == "approved by crew" ||
      orderStatus == "approved by crew chief"
    )
      return (
        <>
          {createAndUpdateButton} {approveByOfficeButton}
          {closeButton}
          {<div style={{ width: "200px", height: "80px" }}></div>}
          {notApproveByOfficeButton}
        </>
      );
    if (orderStatus == "approved by office")
      return (
        <>
          {createAndUpdateButton} {closeButton}
          {<div style={{ width: "400px", height: "80px" }}></div>}
        </>
      );

    if (orderStatus == "inquired")
      return (
        <>
          {" "}
          {createAndUpdateButton} {closeButton}
          {<div style={{ width: "400px", height: "80px" }}></div>}
        </>
      );

    if (orderStatus == "vendor approved")
      return (
        <>
          {" "}
          {createAndUpdateButton} {closeButton}
          {<div style={{ width: "400px", height: "80px" }}></div>}
        </>
      );

    if (orderStatus == "po placed")
      return (
        <>
          {" "}
          {createAndUpdateButton} {closeButton}
          {<div style={{ width: "400px", height: "80px" }}></div>}
        </>
      );

    if (orderStatus == "items in transit")
      return (
        <>
          {" "}
          {submitReceivedButton} {closeButton}{" "}
        </>
      );
    if (orderStatus == "delivered")
      return (
        <>
          {" "}
          {submitReceivedButton} {closeButton}{" "}
        </>
      );

    if (
      ["items in transit", "items received", "delivered"].includes(orderStatus)
    )
      return (
        <>
          {invoiceReceivedButton} {closeButton}
        </>
      );

    return <> {closeButton}</>;
  }
};

const InvoiceReceivedIcon = (invoiceReceivedDate) => {
  if (invoiceReceivedDate === undefined) return <></>;
  const tooltip = (
    <Popover>
      Invoice received {moment(invoiceReceivedDate).format("DD/MM/YYYY")}
    </Popover>
  );
  return (
    <>
      <Whisper
        delay={300}
        placement="bottomStart"
        controlId="control-id-hover"
        trigger="hover"
        speaker={tooltip}
      >
        <img
          style={{
            width: "25px",
          }}
          src={InvoiceIconFile}
          alt="Invoice received"
        />
      </Whisper>
    </>
  );
};
